export const PENDING = 'pending' as const;
export const SUCCESS = 'success' as const;
export const ERROR = 'error' as const;

export const AUTHENTICATED = 'authenticated' as const;
export const NOT_AUTHENTICATED = 'not_authenticated' as const;
